import { render, staticRenderFns } from "./RsaGestionePazientiAdiComponent.vue?vue&type=template&id=710e4b10"
import script from "./RsaGestionePazientiAdiComponent.vue?vue&type=script&lang=js"
export * from "./RsaGestionePazientiAdiComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports